var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options"},_vm._l((_vm.question.get('options')),function(option){return _c('div',{key:option,staticClass:"option",class:{
      right: option == _vm.question.get('answer'),
      wrong:
        _vm.result.get('answer') == option &&
        _vm.result.get('answer') != _vm.question.get('answer'),
    }},[_vm._v("\n    "+_vm._s(option)+"\n  ")])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02ffdb5d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quiz/quiz_question_result/QuizQuestionResultOptions.vue
// module id = 1464
// module chunks = 0